// This is a small script to create a smooth product accordion on the product page

document.querySelectorAll('.custom__accordion details').forEach((details) => {
  const summary = details.querySelector('summary');
  const content = details.querySelector('.accordion__content');
  if (!summary || !content) return;

  summary.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation(); // stops theme/native handlers from snapping it

    const isOpen = details.hasAttribute('open');

    // Cancel any in-flight transition cleanly
    content.style.transition = 'none';
    const current = content.getBoundingClientRect().height; // current rendered height
    content.style.height = current + 'px';
    // force reflow
    content.getBoundingClientRect();
    content.style.transition = '';

    if (isOpen) {
      // CLOSE: animate to 0, then remove open
      content.style.height = '0px';

      const onEnd = (evt) => {
        if (evt.propertyName !== 'height') return;
        details.removeAttribute('open');
        content.style.height = '0px';
        content.removeEventListener('transitionend', onEnd);
      };
      content.addEventListener('transitionend', onEnd, { once: true });
    } else {
      // OPEN: set open, then animate 0 -> scrollHeight, then clear height
      details.setAttribute('open', '');
      content.style.height = '0px';
      // next frame: animate up
      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + 'px';
      });

      const onEnd = (evt) => {
        if (evt.propertyName !== 'height') return;
        content.style.height = 'auto'; // let it size naturally while open
        content.removeEventListener('transitionend', onEnd);
      };
      content.addEventListener('transitionend', onEnd, { once: true });
    }
  });
});
